// AutoMapper
import { AutoMap } from '@nartc/automapper';

// Class transformer
import { Type } from 'class-transformer';

export class PersonalInformationVm {
    @AutoMap() Id: number;
    @AutoMap() @Type(() => Date) ReferenceDate: Date;
    @AutoMap() @Type(() => Date) InsureeDateOfBirth: Date;
    @AutoMap() PostalCode: string;
    @AutoMap() HouseNumber: string;
    @AutoMap() HealthInsuranceNumber: string;
    @AutoMap() TravelInsuranceNumber: string;

    public constructor(init?: Partial<PersonalInformationVm>) {
        Object.assign(this, init);
    }
}